import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { apiKeyQueries } from '@/features/api-keys/queries'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'

import { ROLES } from '@/shared/auth/constants'
import { roleAuthGuard } from '@/shared/auth/utils/router'
import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

import {
	SettingsCard,
	SettingsCardTitle,
} from '@/components/common/settings-card'

const ApiKeysTable = lazy(
	() => import('@/features/api-keys/components/api-keys-table'),
)

const searchSchema = z.object({
	q: z.string().optional(),
	filters: z.record(z.string(), z.string()).optional(),
})

export const Route = createFileRoute(
	'/_dashboard/settings/tenant-settings/api-keys',
)({
	validateSearch: zodValidator(searchSchema),

	beforeLoad: () => roleAuthGuard(ROLES.Admin),

	loader: ({ context: { queryClient } }) => {
		queryClient.ensureQueryData({
			...apiKeyQueries.list(),
			revalidateIfStale: true,
		})
	},

	head: () => ({
		meta: [
			{
				title: 'API Keys | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RouteSkeleton,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<SettingsCard>
			<SettingsCardTitle>API Keys</SettingsCardTitle>

			<Suspense fallback={<TableFullSkeleton className="w-full" rows={10} />}>
				<ApiKeysTable />
			</Suspense>
		</SettingsCard>
	)
}

function RouteSkeleton() {
	return (
		<SettingsCard>
			<SettingsCardTitle>API Keys</SettingsCardTitle>

			<TableFullSkeleton className="w-full" rows={10} />
		</SettingsCard>
	)
}
